import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/updateBottomNavIconDesign/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showUpdateBottomNavIconDesignSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showUpdateBottomNavIconDesignSelector };
